import React, { useEffect, useState } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { IBrand } from "../models/brand.ts";
import { Import } from "./Import.tsx";
import { Export } from "./Export.tsx";
import { zendeskHttpRequest } from "../lib/api/zendeskHttpRequest.ts";
import { BrandSelect } from "./parts/BrandSelect.tsx";

export const FaqAppContainer: React.FC<{ token: string }> = ({ token }) => {
  const [brands, setBrands] = useState<IBrand[]>([]);
  const [selectBrandUrl, setSelectBrandUrl] = useState<string>("");

  useEffect(() => {
    const fetchBrands = async () => {
      const data = await zendeskHttpRequest<{ brands: IBrand[] }>(
        "brands",
        token,
        "GET",
      );
      const isAscii = (s: string) => /^[A-Za-z0-9]/.test(s);
      const sorted = [...data.brands].sort((a, b) => {
        if (a.default !== b.default) return a.default ? -1 : 1;
        if (isAscii(a.name) !== isAscii(b.name)) return isAscii(a.name) ? 1 : -1;
        return a.name.localeCompare(b.name, "ja");
      });
      setBrands(sorted);
      setSelectBrandUrl(sorted[0].brand_url);
    };
    fetchBrands().catch(console.error);
  }, [token]);

  const handleSelectedBrandChange = (brand: IBrand) => {
    setSelectBrandUrl(brand.brand_url);
  };

  return (
    <Container maxWidth="md">
      <Grid container spacing={2} sx={{ mt: 5 }}>
        <Grid item xs={12}>
          <BrandSelect
            brands={brands}
            onSelectedBrandChange={handleSelectedBrandChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, p: 3 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
              インポート
            </Typography>
            <Import selectBrandUrl={selectBrandUrl} token={token} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Export selectBrandUrl={selectBrandUrl} token={token} />
        </Grid>
      </Grid>
    </Container>
  );
};
